import { Linking, Platform } from 'react-native';
import { getOidcConfig } from './oidcConfig';

/**
 * The A3RN account page — passkeys, "Can't sign in?" and deleting the A3RN
 * account itself — served by the identity provider at `<issuer>/account/`
 * (a3rn-fleet docs/identity.md, "Account deletion"). Derived from the issuer
 * rather than configured, so local (`http://auth.localhost:8080`) and
 * production (`https://auth.a3rn.com`) need nothing extra.
 */
export function accountPageUrl(): string | null {
  const config = getOidcConfig();
  return config ? `${config.issuer}/account/` : null;
}

/** Opened the way the legal links are: a browser sheet on native, a link on web. */
export async function openAccountPage(): Promise<void> {
  const url = accountPageUrl();
  if (!url) return;
  try {
    if (Platform.OS === 'web') {
      await Linking.openURL(url);
      return;
    }
    // Imported at call time for the reason given on openLegalUrl in constants.ts.
    const WebBrowser = await import('expo-web-browser');
    await WebBrowser.openBrowserAsync(url);
  } catch {
    // Nothing to recover: the user is still in Settings.
  }
}
